import styled from 'styled-components';
import _default from '../../themes/default';

export const Container = styled.div`
    background: linear-gradient(343.07deg, rgba(132, 59, 206, 0.06) 5.71%, rgba(132, 59, 206, 0) 64.83%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    clip-path: polygon(0 0, 100% 0, 100% 100%,100% 100%, 0 100%);
    padding: 50px 20px 100px 20px;
`;

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 10px 0px 100px 0;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

export const Title = styled.h1`
  font-size: 42px;
  font-weight: 700;
  text-align: center;
  color: #28ac30; /* Primary green color */
  background: linear-gradient(90deg, #28ac30, #85d67f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.15);

  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;

export const ToggleButtonGroup = styled.div`
    display: flex;
    // flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    border: 1.5px solid ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
    font-size: 13px;
    border-radius: 12px;
    font-weight: 500;
    margin: 22px 0px;
    padding: 0 16px;
    @media (max-width: 768px) {
        justify-content: center; /* Center items horizontally only for smaller devices */
        font-size: 12px;
        flex-wrap: wrap; 
        
    }
`

export const ToggleButton = styled.div`
    padding: 8px 18px;
    border-radius: 6px;
    cursor: pointer;
    ${({ active, theme }) =>
        active && `
    background: ${theme.primary + 20};
    `
    }
    &:hover {
        background: ${({ theme }) => theme.primary + 8};
    }
    @media (max-width: 768px) {
        padding: 6px 8px;
        border-radius: 4px;
    }
`
export const Divider = styled.div`
    width: 1.5px;
    background: ${({ theme }) => theme.primary};
`

export const CategoryCards = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 34px;
  width: 100%;
  max-width: 1180px;
  margin-top: 42px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 18px;
  }
`;

export const CategoryCard = styled.button`
  min-height: 340px;
  padding: 34px;
  border: 1px solid rgba(40, 172, 48, 0.28);
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(40, 172, 48, 0.96) 0%, rgba(18, 124, 56, 0.96) 48%, rgba(8, 77, 40, 0.96) 100%),
    radial-gradient(circle at top right, rgba(255, 255, 255, 0.32), transparent 34%);
  color: ${({ theme }) => theme.text_secondary};
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 44px rgba(0,0,0,0.22);
  transition: all 0.25s ease-in-out;

  &::before {
    content: "";
    position: absolute;
    width: 210px;
    height: 210px;
    right: -74px;
    top: -74px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    width: 140px;
    height: 140px;
    right: 36px;
    bottom: -86px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    pointer-events: none;
  }

  &:hover {
    border-color: rgba(255, 255, 255, 0.55);
    transform: translateY(-8px);
    box-shadow: 0 28px 58px rgba(40, 172, 48, 0.3), 0 18px 42px rgba(0,0,0,0.22);
  }

  @media (max-width: 640px) {
    min-height: 310px;
    padding: 26px;
  }
`;

export const CategoryCardHeader = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
`;

export const CategoryCardBadge = styled.span`
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.18);
  color: ${({ theme }) => theme.white};
  border: 1px solid rgba(255, 255, 255, 0.24);
  font-size: 14px;
  font-weight: 900;
`;

export const CategoryCardContent = styled.div`
  position: relative;
  z-index: 1;
  margin-top: 30px;
`;

export const CategoryCardTitle = styled.span`
  display: block;
  max-width: 470px;
  color: ${({ theme }) => theme.white};
  font-size: 34px;
  font-weight: 900;
  line-height: 1.12;

  @media (max-width: 640px) {
    font-size: 28px;
  }
`;

export const CategoryCardText = styled.span`
  display: block;
  margin-top: 18px;
  max-width: 520px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 16px;
  line-height: 1.65;

  @media (max-width: 640px) {
    font-size: 15px;
    line-height: 1.55;
  }
`;

export const CategoryCardAction = styled.span`
  position: relative;
  z-index: 1;
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 28px;
  padding: 11px 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.primary};
  font-size: 14px;
  font-weight: 900;

  &::after {
    content: "→";
    font-size: 17px;
    line-height: 1;
    transition: transform 0.2s ease-in-out;
  }

  ${CategoryCard}:hover &::after {
    transform: translateX(3px);
  }
`;

export const CategoryBackButton = styled.button`
  align-self: flex-start;
  margin-top: 22px;
  padding: 9px 14px;
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;

  &:hover {
    background: ${({ theme }) => theme.primary + 12};
  }
`;


export const CardContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 28px;
    flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 32px;
    grid-auto-rows: minmax(100px, auto);
    @media (max-width: 960px) {
        grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 640px) {
        grid-template-columns: repeat(1, 1fr);
    }
`;

export const ProgramGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  width: 100%;
  margin-top: 18px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const ProgramCard = styled.button`
  min-height: 390px;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.primary + 30};
  border-radius: 8px;
  box-shadow: 0 0 12px 3px rgba(0,0,0,0.28);
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  cursor: pointer;
  text-align: left;
  transition: all 0.25s ease-in-out;

  &:hover {
    transform: translateY(-8px);
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 18px 40px rgba(0,0,0,0.34);
  }
`;

export const ProgramImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  object-position: center top;
  background: #e4eee5;

  @media (max-width: 640px) {
    height: auto;
    aspect-ratio: 16 / 10;
    object-fit: contain;
    background: #e4eee5;
  }
`;

export const ProgramCardBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  padding: 16px 18px 10px;
`;

export const ProgramMeta = styled.div`
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  background: ${({ theme }) => theme.primary + 18};
  color: ${({ theme }) => theme.primary};
  font-size: 12px;
  font-weight: 700;
`;

export const ProgramTitle = styled.h2`
  color: ${({ theme }) => theme.text_secondary};
  font-size: 23px;
  line-height: 1.2;
  margin: 0;
`;

export const ProgramDesc = styled.p`
  color: ${({ theme }) => theme.text_secondary + 99};
  font-size: 15px;
  line-height: 1.55;
  margin: 0;
`;

export const ProgramCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 18px 18px;
  color: ${({ theme }) => theme.text_secondary + 99};
  font-size: 13px;
  font-weight: 700;
`;

export const ProgramCourseLink = styled.a`
  justify-self: end;
  color: ${({ theme }) => theme.primary};
  font-size: 14px;
  font-weight: 700;
  line-height: 1.35;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export const ProgramButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 8px;
  background: ${({ dull, theme }) => dull ? 'transparent' : theme.primary};
  color: ${({ dull, theme }) => dull ? theme.primary : theme.white};
  font-size: 14px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
`;

export const ProgramDetail = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const ProgramDetailHero = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, 0.9fr) minmax(0, 1.1fr);
  gap: 22px;
  width: 100%;
  align-items: stretch;
  padding: 18px;
  border: 1px solid ${({ theme }) => theme.primary + 30};
  border-radius: 8px;
  background: ${({ theme }) => theme.card};
  box-shadow: 0 0 12px 3px rgba(0,0,0,0.24);

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

export const ProgramDetailImage = styled.img`
  width: 100%;
  height: 100%;
  min-height: 280px;
  object-fit: cover;
  object-position: center top;
  border-radius: 8px;
  background: #e4eee5;

  @media (max-width: 640px) {
    min-height: 230px;
    object-fit: contain;
  }
`;

export const ProgramDetailContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
`;

export const ProgramDetailTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 34px;
  line-height: 1.15;

  @media (max-width: 640px) {
    font-size: 28px;
  }
`;

export const ProgramDetailActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
`;

export const ProgramInfoSection = styled.section`
  width: 100%;
  padding: 16px 18px;
  border: 1px solid ${({ theme }) => theme.primary + 22};
  border-radius: 8px;
  background: ${({ theme }) => theme.card};
`;

export const ProgramSectionTitle = styled.h3`
  margin: 0 0 10px;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 22px;
  line-height: 1.25;
`;

export const ProgramSectionText = styled.p`
  margin: 0 0 8px;
  color: ${({ theme }) => theme.text_secondary + 99};
  font-size: 15px;
  line-height: 1.65;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ProgramSectionList = styled.ul`
  display: grid;
  gap: 5px;
  margin: 0;
  padding-left: 20px;
  list-style: disc;
  list-style-position: outside;
  color: ${({ theme }) => theme.text_secondary + 99};
  font-size: 15px;
  line-height: 1.55;

  li {
    display: list-item;
  }

  li::marker {
    color: ${({ theme }) => theme.primary};
  }
`;

export const ProgramListLabel = styled.div`
  margin: 12px 0 6px;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
  font-weight: 800;
  line-height: 1.4;
`;

export const ProgramSubsection = styled.div`
  margin-top: 12px;

  &:first-child {
    margin-top: 0;
  }
`;

export const ProgramSubsectionTitle = styled.h4`
  margin: 0 0 8px;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 16px;
  line-height: 1.35;
`;

export const ProgramBottomActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.primary + 22};
  border-radius: 8px;
  background: ${({ theme }) => theme.card};
`;

export const ProgramCourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  width: 100%;

  @media (max-width: 1060px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const ProgramCourseItem = styled.div`
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
  min-height: 64px;
  padding: 10px 12px;
  border: 1px solid ${({ theme }) => theme.primary + 22};
  border-radius: 8px;
  background: ${({ theme }) => theme.card};
`;

export const ProgramCourseNumber = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${({ theme }) => theme.primary + 18};
  color: ${({ theme }) => theme.primary};
  font-size: 13px;
  font-weight: 900;
`;

export const ProgramCourseTitle = styled.div`
  color: ${({ theme }) => theme.text_secondary};
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
`;

export const ProgramCourseStatus = styled.div`
  justify-self: end;
  color: ${({ theme }) => theme.text_secondary + 88};
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
`;

export const ApplicationOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  background-color: #000000a7;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding: 40px 16px;
`;

export const ApplicationFormContainer = styled.div`
  width: 100%;
  max-width: 760px;
  position: relative;
  border-radius: 12px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text_primary};
  padding: 28px;
  box-shadow: 0 18px 50px rgba(0,0,0,0.35);

  @media (max-width: 640px) {
    padding: 24px 18px;
  }
`;

export const ApplicationTitle = styled.h2`
  margin: 4px 36px 22px 0;
  color: ${({ theme }) => theme.text_primary};
  font-size: 26px;
  line-height: 1.25;

  @media (max-width: 640px) {
    font-size: 22px;
  }
`;

export const ApplicationForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ApplicationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const ApplicationInput = styled.input`
  width: 100%;
  min-height: 48px;
  padding: 12px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f8f8f8;
  color: #111;
  font-size: 15px;

  &:focus {
    border-color: ${({ theme }) => theme.primary};
    outline: none;
    background: #fff;
  }
`;

export const ApplicationSelect = styled.select`
  width: 100%;
  min-height: 48px;
  padding: 12px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f8f8f8;
  color: #111;
  font-size: 15px;

  &:focus {
    border-color: ${({ theme }) => theme.primary};
    outline: none;
    background: #fff;
  }
`;

export const ApplicationTextarea = styled.textarea`
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #f8f8f8;
  color: #111;
  font-size: 15px;
  resize: vertical;

  &:focus {
    border-color: ${({ theme }) => theme.primary};
    outline: none;
    background: #fff;
  }
`;

export const ApplicationCheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
  line-height: 1.45;

  input {
    width: 18px;
    height: 18px;
    margin-top: 1px;
    accent-color: ${({ theme }) => theme.primary};
    flex: 0 0 auto;
  }
`;

export const ApplicationSubmitButton = styled.button`
  width: 100%;
  min-height: 48px;
  border: none;
  border-radius: 8px;
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.white};
  cursor: pointer;
  font-size: 16px;
  font-weight: 800;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

export const NoticeOverlay = styled.div`
  min-height: 100%;
  width: 100%;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.58);
`;

export const NoticeCard = styled.div`
  width: min(440px, 100%);
  padding: 28px;
  border-radius: 8px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text_secondary};
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.34);
  position: relative;
  text-align: center;
`;

export const NoticeIcon = styled.div`
  width: 54px;
  height: 54px;
  margin: 0 auto 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ tone, theme }) => tone === 'error' ? 'rgba(220, 38, 38, 0.12)' : theme.primary + 20};
  color: ${({ tone, theme }) => tone === 'error' ? '#dc2626' : theme.primary};
  font-size: 28px;
  font-weight: 900;
`;

export const NoticeTitle = styled.h3`
  margin: 0 0 10px;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 22px;
  line-height: 1.25;
`;

export const NoticeMessage = styled.p`
  margin: 0 0 22px;
  color: ${({ theme }) => theme.text_secondary + 99};
  font-size: 15px;
  line-height: 1.55;
`;

export const NoticeButton = styled.button`
  min-width: 120px;
  min-height: 42px;
  padding: 10px 18px;
  border: none;
  border-radius: 8px;
  background: ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.white};
  cursor: pointer;
  font-size: 15px;
  font-weight: 800;
`;



export const SearchInput = styled.input`
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #28ac30;
  margin: 20px 0;
  width: 100%;
  max-width: 400px;

  &:focus {
    border: 1px solid #28ac30;
    outline: none;
  }
`;

export const ResultsSummary = styled.div`
  color: ${({ theme }) => theme.text_secondary + 99};
  font-size: 14px;
  margin-bottom: 10px;
`;

export const Pagination = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 38px;
`;

export const PaginationButton = styled.button`
  min-width: 92px;
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 8px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text_secondary};
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.primary + 15};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const PageButton = styled.button`
  width: 40px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.primary};
  border-radius: 8px;
  background: ${({ active, theme }) => active ? theme.primary : theme.card};
  color: ${({ active, theme }) => active ? theme.white : theme.text_secondary};
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: ${({ active, theme }) => active ? theme.primary : theme.primary + 15};
  }
`;
